import Cookies from "universal-cookie";
import { COOKIE_STRING } from "../../services/api/api-client";
const authCookieName = window["APP_SETTINGS"].AUTH_COOKIE_NAME;
const cookieTempName =
  authCookieName?.length > 0
    ? authCookieName
    : COOKIE_STRING?.length > 0 ? COOKIE_STRING : "triyo-token-app";

export const getToken = () => {
  const cookies = new Cookies();

  const tokenSources = [
    cookies.get(cookieTempName),
    localStorage.getItem("tmpTriyoTokenApp"),
    cookies.get(cookieTempName + "-api")
  ];

  return tokenSources.find(token => token?.length > 0) || "";
};

export const setAuthCookie = (token) => {
  let cookies = new Cookies();
  token = token || "";

  removeAuthCookie();

  cookies.set(cookieTempName, token);
  cookies.set(cookieTempName, token, {
    domain: "." + window.location.hostname,
    path: "/",
  });

  cookies.set(cookieTempName + "-api", token);
  cookies.set(cookieTempName + "-api", token, {
    domain: "." + window.location.hostname,
    path: "/",
  });

  localStorage.setItem("tmpTriyoTokenApp", token);
};

export const removeAuthCookie = () => {
  let cookies = new Cookies();

  cookies.remove(cookieTempName);
  cookies.remove(cookieTempName, {
    domain: "." + window.location.hostname,
    path: "/",
  });

  cookies.remove(cookieTempName + "-api");
  cookies.remove(cookieTempName + "-api", {
    domain: "." + window.location.hostname,
    path: "/",
  });

  localStorage.removeItem("tmpTriyoTokenApp");
};

const createFetchOptions = ({ method, body }) => {
  let token = getToken();
  return {
    method,
    body: JSON.stringify(body),
    withCredentials: true,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
};

export const createFetchGetOptions = () => createFetchOptions({ method: "GET" });
export const createFetchPostOptions = (body) => createFetchOptions({ method: "POST", body });
export const createFetchPutOptions = (body) => createFetchOptions({ method: "PUT", body });
export const createFetchDeleteOptions = (body) => createFetchOptions({ method: "DELETE", body });

export const createURLWithQueryParams = (url, queryParams = {}) => {
  const newUrl = new URL(url);

  Object.keys(queryParams).forEach((key) => {
    if (queryParams[key] == null) return;
    newUrl.searchParams.append(key, queryParams[key]);
  });

  return newUrl;
};
